import { useTranslation } from 'next-i18next';

import { ProductPrice } from '../../../ProductPrice/ProductPrice';
import { CurrencyCode } from '../types';

export interface FramingSubtotalProps {
  amount: number;
  currencyCode?: CurrencyCode;
}

export const FramingSubtotal = ({
  amount,
  currencyCode,
}: FramingSubtotalProps) => {
  const { t } = useTranslation('checkout');

  return (
    <dl className="flex w-full justify-between">
      <dt>{t('framing.subtotal')}</dt>
      <dd>
        <ProductPrice
          currencyCode={currencyCode}
          price={amount}
          skipConvertCurrency={!!currencyCode}
          skipTaxCalculation
        />
      </dd>
    </dl>
  );
};
